<template>
  <el-dialog :visible.sync="dialogVisible" title="新建学段" custom-class="custom-dialog" :close-on-click-modal="false"
    @opened="dialogOpen" @closed="dialogClose" width="390px" append-to-body>
    <el-form ref="form" :model="form" :inline="true" label-width="80px" class="demo-form-inline">
 
      <el-form-item label="学段">
            <el-checkbox-group  v-model="form.esName" v-if="stageData.length > 0">
                <el-checkbox v-for="stage in stageData" :label="stage" :key="stage">{{stage}}</el-checkbox>
            </el-checkbox-group>
            <div v-else style="color: red; font-weight: bold;">学段已全部生成</div>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer"  v-if="stageData.length > 0">
      <el-button @click="dialogClose">取消</el-button>
      <el-button :loading="loading" type="primary" @click="save">确定</el-button>
    </div>

  </el-dialog>
</template>
<script>
 
import http from '../../../../../../common/http';

export default {
  name: 'add',
  components: {},
  props: {
    deptId: {
      type: String,
      default() {
        return ""
      }
    },
    parentData: {
      type: Array,
      default() {
        return []
      }
    },
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        esName: [],
      },
      stageData: ['幼儿园', '小学', '初中']
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
  },
  methods: {
    dialogOpen() {
      // 初始数据
      this.form.esName = []
      this.stageData = []

      if (this.parentData.length == 0){
        this.stageData = ['幼儿园', '小学', '初中']
      }else{
         let vals = new Array()
         for(let i =0;i<this.parentData.length;i++){
           vals.push(this.parentData[i].esName)
         }

         let tempVals=['幼儿园', '小学', '初中']
         for(let j = 0;j<tempVals.length;j++){
           if(vals.join(',').indexOf(tempVals[j]) ==-1){
              this.stageData.push(tempVals[j])
           }
         }

      }
    },
    // 保存
    save() {

      if(this.form.esName.length == 0){
        this.$commonFn.showTip('学段不可为空，请选择',3)
        return
      }

      let url= this.archiveSetEducationalStageSavetUrl
      let data = {
          deptId:this.deptId,
          educationalStageValue:this.form.esName.join(','),
      }
      // console.log(JSON.stringify(data))
      // return;
      
      this.loading = true
      this.apiPost(url, data).then((res) => {
          if(res.status == 200){
              this.$commonFn.showTip(res.message,1)
              
              this.loading = false;
              this.dialogVisible = false;
              this.$emit('submit')
          }else{
              this.$commonFn.showTip(res.message,3)
          }
          this.loading = false
      }, (err) => {
          console.log(err);
      });
    },
    dialogClose() {
      this.$refs.form.resetFields()
      this.dialogVisible = false
    }
  },
  mixins: [http]
}
</script>


// WEBPACK FOOTER //
// src/components/page/sys/dept/setgrade/components/addForm.vue